import { DevcieTableDefination, ColumnType } from "@core/types";

export const GENERAL_COLUMN: Array<DevcieTableDefination> = [
    /* Model */
    {
        key: "MODEL",
        name: "DEVICE_COLUMN.MODEL",
        sortable: true,
        colvis: false,
        defaultDisplay: true,
        filterable: true,
        filterType: ColumnType.DEVICE,
        filterKeyword: true,
        filterMultiple: true,
        width: 130,
        class: "MODEL-Cell",
        placeholder: "Ex. MX-1000, MX-1200",
        searchable: true
    },
    /* Radio Type */
    {
        key: "IMEI",
        name: "DEVICE_COLUMN.RADIO_TYPE",
        sortable: false,
        colvis: true,
        defaultDisplay: true,
        filterable: true,
        filterType: ColumnType.NETWORK,
        custom: true,
        width: 130,
        class: "Radio-Type-Cell",
        searchable: false
    },
    /* MAC */
    {
        key: "MAC",
        name: "DEVICE_COLUMN.MAC",
        sortable: true,
        colvis: false,
        defaultDisplay: true,
        filterable: true,
        filterType: ColumnType.DEVICE,
        filterKeyword: true,
        filterMultiple: true,
        width: 130,
        class: "MAC-Cell",
        placeholder: "Ex. 600347XXXXX1, 600347XXXXX2",
        searchable: true
    },
    /* Name */
    {
        key: "name",
        name: "DEVICE_COLUMN.NAME",
        sortable: true,
        colvis: true,
        defaultDisplay: true,
        filterable: true,
        filterType: ColumnType.DEVICE,
        filterKeyword: true,
        filterMultiple: false,
        width: 200,
        class: "name-Cell",
        placeholder: "Ex. BEC Units",
        searchable: true
    },
    /* Tags */
    {
        key: "tags",
        name: "DEVICE_COLUMN.TAGS",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.DEVICE,
        custom: true,
        width: 250,
        class: "tags-Cell",
        searchable: false
    },
    /* Address */
    {
        key: "address",
        name: "DEVICE_COLUMN.ADDRESS",
        sortable: false,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.DEVICE,
        width: 250,
        class: "Address-Cell",
        searchable: true
    },
    /* Latitude */
    {
        key: "latitude",
        name: "DEVICE_COLUMN.LATITUDE",
        sortable: false,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.DEVICE,
        width: 130,
        class: "Latitude-Cell",
        searchable: false
    },
    /* Longitude */
    {
        key: "longitude",
        name: "DEVICE_COLUMN.LONGITUDE",
        sortable: false,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.DEVICE,
        width: 130,
        class: "Longitude-Cell",
        searchable: false
    },
    /* Altitude */
    {
        key: "GPS_ALTITUDE",
        name: "DEVICE_COLUMN.ALTITUDE_M",
        sortable: false,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.DEVICE,
        width: 130,
        class: "Altitude-Cell",
        searchable: false
    },
    /* Custom Field */
    {
        key: "customField",
        name: "DEVICE_COLUMN.CUSTOM_FIELD",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.DEVICE,
        filterKeyword: true,
        filterMultiple: false,
        width: 200,
        class: "customField-Cell",
        placeholder: "Ex. ABC",
        searchable: true
    },
    /* IP */
    {
        key: "IP",
        name: "DEVICE_COLUMN.IP",
        sortable: true,
        colvis: true,
        defaultDisplay: true,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: true,
        width: 130,
        class: "IP-Cell",
        placeholder: "Ex. 1.1.1.1, 2.2.2.2",
        searchable: true
    },
    /* IPv6 */
    {
        key: "IPV6",
        name: "DEVICE_COLUMN.IPV6",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: true,
        width: 200,
        class: "IPV6-Cell",
        searchable: true
    },
    /* APN2 IP */
    {
        key: "APN2_IP",
        name: "DEVICE_COLUMN.APN2_IP",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.NETWORK,
        width: 140,
        class: "APN2_IP-Cell",
        searchable: true
    },
    /* FirmWare */
    {
        key: "FW",
        name: "DEVICE_COLUMN.FW",
        sortable: true,
        colvis: true,
        defaultDisplay: true,
        filterable: true,
        filterType: ColumnType.HARDWARE,
        filterKeyword: true,
        filterMultiple: true,
        width: 140,
        class: "FW-Cell",
        searchable: true
    },
    /* CFG */
    {
        key: "configuration",
        name: "DEVICE_COLUMN.CFG",
        sortable: false,
        colvis: true,
        defaultDisplay: true,
        filterable: false,
        filterType: ColumnType.HARDWARE,
        custom: true,
        width: 50,
        class: "configuration-Cell",
        searchable: false
    },
    /* Email Alert */
    {
        key: "alert",
        name: "DEVICE_COLUMN.EMAIL_ALERT",
        sortable: false,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.DEVICE,
        custom: true,
        width: 150,
        class: "email-alert-Cell",
        searchable: false
    },
    /* IMEI */
    {
        key: "IMEI",
        name: "DEVICE_COLUMN.IMEI",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: true,
        filterMultiple: true,
        width: 150,
        class: "IMEI-Cell",
        searchable: true
    },
    /* IMSI */
    {
        key: "IMSI",
        name: "DEVICE_COLUMN.IMSI",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: true,
        filterMultiple: true,
        width: 150,
        class: "IMSI-Cell",
        searchable: true
    },
    /* Host Name */
    {
        key: "HOST_NAME",
        name: "DEVICE_COLUMN.HOST_NAME",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: true,
        filterMultiple: true,
        width: 150,
        class: "HOST_NAME-Cell",
        searchable: true
    },
    /* RSRP */
    {
        key: "RSRP",
        name: "DEVICE_COLUMN.RSRP",
        sortable: true,
        colvis: true,
        defaultDisplay: true,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "RSRP-Cell",
        searchable: false
    },
    /* RSRP2 */
    {
        key: "RSRP2",
        name: "DEVICE_COLUMN.RSRP2",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "RSRP2-Cell",
        searchable: false
    },
    /* RSRP3 */
    {
        key: "RSRP3",
        name: "DEVICE_COLUMN.RSRP3",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "RSRP3-Cell",
        searchable: false
    },
    /* NR RSRP */
    {
        key: "NR_RSRP",
        name: "DEVICE_COLUMN.NR_RSRP",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "NR_RSRP-Cell",
        searchable: false
    },
    /* RSRQ */
    {
        key: "RSRQ",
        name: "DEVICE_COLUMN.RSRQ",
        sortable: true,
        colvis: true,
        defaultDisplay: true,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "RSRQ-Cell",
        searchable: false
    },
    /* RSRQ2 */
    {
        key: "RSRQ2",
        name: "DEVICE_COLUMN.RSRQ2",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "RSRQ2-Cell",
        searchable: false
    },
    /* RSRQ3 */
    {
        key: "RSRQ3",
        name: "DEVICE_COLUMN.RSRQ3",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "RSRQ3-Cell",
        searchable: false
    },
    /* NR RSRQ */
    {
        key: "NR_RSRQ",
        name: "DEVICE_COLUMN.NR_RSRQ",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "NR_RSRQ-Cell",
        searchable: false
    },
    /* RSSI */
    {
        key: "RSSI",
        name: "DEVICE_COLUMN.RSSI",
        sortable: true,
        colvis: true,
        defaultDisplay: true,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "RSSI-Cell",
        searchable: false
    },
    /* RSSI2 */
    {
        key: "RSSI2",
        name: "DEVICE_COLUMN.RSSI2",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "RSSI2-Cell",
        searchable: false
    },
    /* RSSI3 */
    {
        key: "RSSI3",
        name: "DEVICE_COLUMN.RSSI3",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "RSSI3-Cell",
        searchable: false
    },
    /* SINR */
    {
        key: "SINR",
        name: "DEVICE_COLUMN.SINR",
        sortable: true,
        colvis: true,
        defaultDisplay: true,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "SINR-Cell",
        searchable: false
    },
    /* SINR2 */
    {
        key: "SINR2",
        name: "DEVICE_COLUMN.SINR2",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "SINR2-Cell",
        searchable: false
    },
    /* SINR3 */
    {
        key: "SINR3",
        name: "DEVICE_COLUMN.SINR3",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "SINR3-Cell",
        searchable: false
    },
    /* NR SINR */
    {
        key: "NR_SINR",
        name: "DEVICE_COLUMN.NR_SINR",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.SIGNAL,
        custom: true,
        width: 90,
        class: "NR_SINR-Cell",
        searchable: false
    },
    /* NETWORK */
    {
        key: "NETWORK",
        name: "DEVICE_COLUMN.NETWORK",
        sortable: true,
        colvis: true,
        defaultDisplay: true,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: true,
        filterMultiple: false,
        width: 200,
        class: "NETWORK-Cell",
        placeholder: "Ex. BEC Network",
        searchable: true
    },
    /* NETMODE */
    {
        key: "NETMODE",
        name: "DEVICE_COLUMN.NETMODE",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: false,
        width: 200,
        class: "NETMODE-Cell",
        placeholder: "Ex. LTE",
        searchable: true
    },
    /* WAN */
    {
        key: "WAN",
        name: "DEVICE_COLUMN.WAN",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: false,
        width: 200,
        class: "WAN-Cell",
        placeholder: "Ex. EWAN",
        searchable: true
    },
    /* Carrier */
    {
        key: "Carrier",
        name: "DEVICE_COLUMN.CARRIER",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: true,
        filterMultiple: false,
        width: 200,
        class: "Carrier-Cell",
        placeholder: "Ex. Carrier",
        searchable: true
    },
    /* MDN */
    {
        key: "LTE_MDN",
        name: "DEVICE_COLUMN.MDN",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: true,
        filterMultiple: false,
        width: 200,
        class: "MDN-Cell",
        placeholder: "Ex. MDN",
        searchable: true
    },
    /* PCI */
    {
        key: "PCI",
        name: "DEVICE_COLUMN.PCI",
        sortable: true,
        colvis: true,
        defaultDisplay: true,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: true,
        width: 90,
        class: "PCI-Cell",
        searchable: true
    },
    /* ECI */
    {
        key: "ECI", // "ECI",
        name: "DEVICE_COLUMN.ECI",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: true,
        width: 150,
        class: "ECI-Cell",
        searchable: true
    },
    /* CELL_ID */
    {
        key: "CELL_ID",
        name: "DEVICE_COLUMN.SECTOR_ID",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: true,
        width: 150,
        class: "CELL_ID-Cell",
        searchable: true
    },
    /* ENB ID */
    {
        key: "ENB_ID",
        name: "DEVICE_COLUMN.ENB", // "eNB/gNB",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: true,
        width: 150,
        class: "ENB_ID-Cell",
        searchable: true
    },
    /* NCI */
    {
        key: "NCI", // "NCI",
        name: "DEVICE_COLUMN.NCI",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: true,
        width: 150,
        class: "NCI-Cell",
        searchable: true
    },
    /* NR_CELL_ID */
    {
        key: "NR_CELL_ID",
        name: "DEVICE_COLUMN.NR_SECTOR_ID",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: true,
        width: 150,
        class: "NR_CELL_ID-Cell",
        searchable: true
    },
    /* ENB ID */
    {
        key: "GNB_ID",
        name: "DEVICE_COLUMN.GNB",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: true,
        width: 150,
        class: "GNB_ID-Cell",
        searchable: true
    },
    /* NCI and ECI */
    {
        key: "CELLID", // "CELLID",
        name: "DEVICE_COLUMN.CELL_ID",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: true,
        width: 150,
        class: "CELLID-Cell",
        searchable: true
    },
    /* BAND */
    {
        key: "BAND",
        name: "DEVICE_COLUMN.BAND",
        sortable: true,
        colvis: true,
        defaultDisplay: true,
        filterable: true,
        filterType: ColumnType.NETWORK,
        filterKeyword: false,
        filterMultiple: true,
        width: 100,
        class: "BAND-Cell",
        searchable: true
    },
    /* CardFw */
    {
        key: "CardFw",
        name: "DEVICE_COLUMN.CARD_FW",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.HARDWARE,
        filterKeyword: true,
        filterMultiple: true,
        width: 250,
        class: "CardFw-Cell",
        searchable: true
    },
    /* RI */
    {
        key: "RI",
        name: "DEVICE_COLUMN.RI",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.NETWORK,
        // filterKeyword: false,
        // filterMultiple: true,  
        width: 100,
        class: "RI-Cell",
        searchable: false
    },
    /* NR RI */
    {
        key: "NR_RI",
        name: "DEVICE_COLUMN.NR_RI",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.NETWORK,
        // filterKeyword: false,
        // filterMultiple: true,  
        width: 100,
        class: "NR_RI-Cell",
        searchable: false
    },
    /* DL MCS */
    {
        key: "DL_MCS",
        name: "DEVICE_COLUMN.DL_MCS",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.NETWORK,
        // filterKeyword: false,
        // filterMultiple: true,  
        width: 120,
        class: "DL_MCS-Cell",
        searchable: false
    },
    /* NR_DLMCS */
    {
        key: "NR_DLMCS",
        name: "DEVICE_COLUMN.NR_DLMCS",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.NETWORK,
        // filterKeyword: false,
        // filterMultiple: true,  
        width: 120,
        class: "NR_DLMCS-Cell",
        searchable: false
    },
    /* NR_ULMCS */
    {
        key: "NR_ULMCS",
        name: "DEVICE_COLUMN.NR_ULMCS",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.NETWORK,
        // filterKeyword: false,
        // filterMultiple: true,  
        width: 120,
        class: "NR_ULMCS-Cell",
        searchable: false
    },
    /* CQI */
    {
        key: "CQI",
        name: "DEVICE_COLUMN.CQI",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.NETWORK,
        // filterKeyword: false,
        // filterMultiple: true,  
        width: 100,
        class: "CQI-Cell",
        searchable: false
    },
    /* NR CQI */
    {
        key: "NR_CQI",
        name: "DEVICE_COLUMN.NR_CQI",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.NETWORK,
        // filterKeyword: false,
        // filterMultiple: true,  
        width: 100,
        class: "NR_CQI-Cell",
        searchable: false
    },
    /* ICCID */
    {
        key: "ICCID",
        name: "DEVICE_COLUMN.ICCID",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.NETWORK,
        width: 200,
        class: "ICCID-Cell",
        searchable: true
    },
    /* CBSD STATUS */
    {
        key: "CBSD_STATUS",
        name: "DEVICE_COLUMN.CBSD",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.NETWORK,
        width: 200,
        class: "CBSD_STATUS-Cell",
        searchable: false
    },
    /* LTEUPTIME */
    {
        key: "LTE_UPTIME",
        name: "DEVICE_COLUMN.CONN_UPTIME",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.DEVICE,
        custom: true,
        width: 150,
        class: "LTE_UPTIME-Cell",
        searchable: false
    },
    /* SYSUPTIME */
    {
        key: "SYSUPTIME",
        name: "DEVICE_COLUMN.SYS_UPTIME",
        sortable: true,
        colvis: true,
        defaultDisplay: true,
        filterable: false,
        filterType: ColumnType.DEVICE,
        custom: true,
        width: 150,
        class: "SYSUPTIME-Cell",
        searchable: false
    },
    /* Last Connect */
    {
        key: "lastPublishedAt",
        name: "DEVICE_COLUMN.LAST_CONNECT",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.DEVICE,
        custom: true,
        width: 200,
        class: "LastConnect-Cell",
        searchable: false
    },
    /* Temp */
    {
        key: "TEMP",
        name: "DEVICE_COLUMN.TEMP_C",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.HARDWARE,
        custom: false,
        width: 120,
        class: "Temperature-Cell",
        searchable: false
    },
    /* Switch Status */
    {
        key: "switch",
        name: "DEVICE_COLUMN.SWITCH_STATUS",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: false,
        filterType: ColumnType.DEVICE,
        custom: true,
        width: 120,
        class: "Switch-Status-Cell",
        searchable: false
    }
];

export const DEVICE_DATA_TABLE_DEF_GROUP: Array<DevcieTableDefination> = [
    /* GROUP */
    {
        key: "groupId",
        name: "DEVICE_COLUMN.GROUP",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.DEVICE,
        filterKeyword: false,
        filterMultiple: false,
        custom: true,
        width: 120,
        class: "group-Cell",
        searchable: false
    }
];

export const DEVICE_DATA_TABLE_DEF_OWNER: Array<DevcieTableDefination> = [
    /* OWNER */
    {
        key: "CustID",
        name: "DEVICE_COLUMN.OWNER",
        sortable: true,
        colvis: true,
        defaultDisplay: false,
        filterable: true,
        filterType: ColumnType.DEVICE,
        filterKeyword: true,
        filterMultiple: false,
        custom: false,
        width: 120,
        class: "owner-Cell",
        searchable: true
    }
];
